import { DTOForgeProjectContextV2, DTOForgeProjectTheme, } from "./project-context-v2";
import z from "zod";
export const DTOProjectContextOverride = z.object({
    projectId: z.string(),
    theme: DTOForgeProjectTheme.partial(),
    themePreset: z.string().optional(),
});
export const DTOProjectContextOverrideInput = z.object({
    updateSharedContext: z.boolean().optional(),
    theme: DTOForgeProjectTheme.partial(),
    themePreset: z.string().optional(),
});
// TS7056 workaround. DTOForgeProjectContextV2 embeds the recursive scope tree
// and appears twice here, so a whole-composite `z.infer<...>` would expand both
// copies inline and overflow the .d.ts emit limit. The cast keeps `.parse()`
// typed via the manual alias below — runtime validation is unchanged.
//
// Alternatives ruled out:
//   - `z.ZodType<X>` annotation → `.nullish()` input/output variance error
//   - `z.lazy(() => DTOForgeProjectContextV2)` → same variance error
//   - `z.ZodTypeAny` annotation → consumers lose `.parse()` typing
export const DTOProjectContextOverrideResponse = z.object({
    override: DTOProjectContextOverride,
    originalContext: DTOForgeProjectContextV2,
    resolvedContext: DTOForgeProjectContextV2,
});
